export const IMAGE_FILE_TYPE = 'image/';
export const IMAGE_ALL_FILE_TYPE = 'image/*';
export const PDF_FILE_TYPE = 'application/pdf';



// WEBPACK FOOTER //
// ./app/constants/fileType.js